import "core-js/modules/web.self.js";
export var isInIFrame = function isInIFrame() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};